import { defineComponent } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

import { AdminWalletHistoryTable } from "@/components/pages/admin-wallet";
import { SharedButtonIcon } from "@/components/shared";

import { PAGE_SIZE, SvgAttribute } from "@/shared/constants/constants";
import { SortFactory } from "@/shared/factory/sort";
import { SearchFactory } from "@/shared/factory/search";
import { AdminWalletHistoryResponse } from "@/shared/repository/modules/wallet/repo";
import { AdminHistoryFilterRequest } from "@/shared/constants/interfaces";

export default defineComponent({
  name: COMPONENT_NAME,
  components: {
    AdminWalletHistoryTable,
    SharedButtonIcon,
  },
  data() {
    return {
      isLoading: false,
      isBalance: false,
      isStatus: false,
      sort: SortFactory(),
      search: SearchFactory(),
      walletRepository: this.$projectServices.walletRepository,
      historyRepo: this.$projectServices.historyRepo,
      history: <AdminWalletHistoryResponse[]>[],
    };
  },
  async created() {
    await this.handleFetch();
  },
  computed: {
    displayedIcons(): SvgAttribute {
      return SVG;
    },

    displayedFilter(): AdminHistoryFilterRequest {
      return this.historyRepo.adminFilter;
    },

    isMoreShow(): boolean {
      return this.sort.page * PAGE_SIZE <= this.history.length;
    },
  },
  methods: {
    async handleMore(): Promise<void> {
      this.historyRepo.ADD_PAGE();

      await this.handleFetch(true);
    },
    // async getUsersWalletHistory(): Promise<void> {
    async handleFetch(isMore: boolean = false): Promise<void> {
      try {
        this.isLoading = true;

        if (!isMore) {
          this.history = [];
        }
        const history = await this.walletRepository.adminHistory(
          this.displayedFilter
        );
        if (isMore) {
          this.history = [...this.history, ...history];
        } else {
          this.history = history;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
